import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDEItVIcYaCH1B0B1j9re9tLgEzonO3bP4",
  authDomain: "fup-landing-page-1.firebaseapp.com",
  projectId: "fup-landing-page-1",
  storageBucket: "fup-landing-page-1.firebasestorage.app",
  messagingSenderId: "334295296993",
  appId: "1:334295296993:web:3c26bf7ac39c7d6e4980a0",
  measurementId: "G-6M15LYH99S"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };